import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  studentAnswers: [],
};
const studentAnswerSlice = createSlice({
  name: "studentAnswer",
  initialState,
  reducers: {
    setStudentBlankAnswer: (state, action) => {
      state.studentAnswers = action.payload;
    },
  },
});

export const { setStudentBlankAnswer } = studentAnswerSlice.actions;
export default studentAnswerSlice.reducer;
